import { render, staticRenderFns } from "./illness.vue?vue&type=template&id=0122e298&scoped=true&"
import script from "./illness.vue?vue&type=script&lang=js&"
export * from "./illness.vue?vue&type=script&lang=js&"
import style0 from "./illness.vue?vue&type=style&index=0&id=0122e298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0122e298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0122e298')) {
      api.createRecord('0122e298', component.options)
    } else {
      api.reload('0122e298', component.options)
    }
    module.hot.accept("./illness.vue?vue&type=template&id=0122e298&scoped=true&", function () {
      api.rerender('0122e298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/components/illness.vue"
export default component.exports